import { REACT_APP_API_ENDPOINT } from "../helpers/data";
import { handleResponse, sendPostRequest } from "./apiUtilis";

export const createOrder = async (req) => {
  console.log("createOrder", req)
    try {
        const response = await sendPostRequest(REACT_APP_API_ENDPOINT + "order", req);
        console.error("Response:", response);
        return handleResponse(response);
    } catch (error) {
        console.error("Error in requestContact:", error);
        throw error;  // Re-throw the error after logging it
    }
};